import Icon from "assets/icons";
import { ManageActivityCardProps } from "./types";
import { useCopies } from "shared/hooks/useCopies";

export default function ManageActivityCard(props: ManageActivityCardProps) {
  const copies = useCopies();
  return (
    <div className="manageActivityCard">
      <div className="manageActivityCard_wrapper">
        <div className="manageActivityCard_left">
          <div className="manageActivityCard_left--title">
            {props.name}
            {props.inviteAction}
          </div>
          <div className="manageActivityCard_left--locationAndDate">
            <div className="manageActivityCard_left--locationAndDate__date">
              <Icon.ClockIcon size={15} /> <span>{props.activityDate}</span>
            </div>
            <div className="bulletDot"></div>
            <div className="manageActivityCard_left--locationAndDate__location">
              <Icon.Location size={16} /> {props.activityLocation}
            </div>
          </div>
          <div className="manageActivityCard_left--sponsoredBy">
            <Icon.SponsorLevel size={16} /> {props.activitySponsored}
          </div>
          {props.activityElapsed && (
            <div className="manageActivityCard_left--elapsedTag">
              <span className="activityStatuses status--cancelled">{copies.get("elapsed")}</span>
            </div>
          )}
        </div>
        <div className="manageActivityCard_right">{props.action}</div>
      </div>
    </div>
  );
}
